import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgLtLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 61 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.056 30c0 16.566-13.434 30-30 30-16.566 0-30-13.434-30-30 0-16.566 13.434-30 30-30 16.565 0 30 13.434 30 30Z"
      fill="url(#lt-logo_svg__a)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.972 12.097c-8.852 0-16.018 7.186-16.018 16.032 0 1.047.084 1.661.084 1.661.112.754.822 1.381 1.59 1.381h28.675c.767 0 1.478-.627 1.59-1.381 0 0 .083-.628.083-1.66.014-8.861-7.152-16.033-16.004-16.033Z"
      fill="#FCEE21"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.834 35.358c0 .837-.752 1.535-1.672 1.535H8.643c-.92 0-1.673-.698-1.673-1.535 0-.838.753-1.535 1.673-1.535h42.519c.92 0 1.672.697 1.672 1.535Zm-6.273 5.86c0 .851-.752 1.535-1.673 1.535H14.916c-.92 0-1.673-.684-1.673-1.535 0-.851.753-1.535 1.673-1.535h29.972c.92 0 1.673.684 1.673 1.535Zm-7.528 5.861c0 .851-.752 1.535-1.672 1.535H22.444c-.92 0-1.673-.684-1.673-1.535 0-.851.753-1.535 1.673-1.535h14.917c.92 0 1.672.684 1.672 1.535Z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="lt-logo_svg__a"
        x1={0.061}
        y1={59.995}
        x2={0.061}
        y2={0.005}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3FA9F5" />
        <stop offset={1} stopColor="#00D7FF" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgLtLogo);
export default Memo;
